
import styled from "styled-components"

import descSrc from '../../img/cardBg.png'
export  const DescIcon = styled.img`
  width: 24px;
  position: absolute;
  top: 138px;
  right: 0;
`


export const Ctitle = styled.div`
    position: absolute;
    top: 0px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 0px;
    border-radius: 13px;
    transform: translateY(60%);
    z-index: 1;
  .blue-back {
      border-radius: 15px;
      background-color: #c93432;
        position: relative;
    &::before {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% + 30px);
      height: 30px;
      border-radius: 15px;
      transform: translateX(-15px);
      background-color: #c93432;
    }
    &::after {
        content: ' ';
        position: absolute;
        top: 0;
        left: 0;
        width: calc(100% + 80px);
        height: 20px;
        // border-radius: 15px;
        // transform: ;
        transform: translateX(-40px) translateY(60%);
        background-color: #fff;
      }
  }
  .title {
    background: #fff;
    margin-top: -4px;
    background-image: url(${descSrc});
    border: 2px solid  rgba(255, 255, 255, 1);
    border-radius: 13px 13px 0 0;
    background-repeat: no-repeat;
    background-size: 100% 44px;
    background-repeat: no-repeat;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    color: #511e21;
    font-weight: 600;
    text-align: left;
    img {
      padding-left: 20px;
      padding-top: 10px;
      height: 30px;
    }
  }
`


export const Descp = styled.p`
  font-size: 14px;
  color: #333;
  line-height: 17px;
  text-align: justify;
  .text-l {
    text-align: left;
  }
`

export const Cicon = styled.img`
  position: absolute;
  bottom: -45px;
  z-index: 99999;
  width: 30px;
  left: 50%;
  margin-left: -15px;
`
export const Content = styled.div`
  max-height: 60vh;
  min-height: 30vh;
  overflow: scroll;
  padding: 0 26px;
  .tips {
    text-align: left;
    span {
      color: #f00;
    }
  }
`



// WEBPACK FOOTER //
// ./src/views/activity_170/componens/Desc/style.js